<template>
  <div>
    <GrmBtn color="gray" @click="onBack">{{ $t("testBank.goBack") }}</GrmBtn>
    <div class="mt-4 -mx-3 py-8 px-10 bg-gray-100 lg:mt-10 lg:-mx-10 lg:px10">
      <div class="flex flex-col gap-y-6">
        <div class="flex gap-x-4">
          <div class="min-w-0 flex-1 flex flex-col gap-y-2">
            <div class="w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6">{{ $t("setting.name.title") }}</div>
            <p class="rounded-lg py-3 px-4 bg-white text-sm">{{ testbankExamHistory.examTitle }}</p>
          </div>
          <div class="min-w-0 flex-1 flex flex-col gap-y-2">
            <p class="w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6">{{ $t("testBank.style") }}</p>
            <div>
              <GrmBtn :color="testbankExamHistory.examType === 'QUIZ' ? 'purple' : 'green'"
                      hoverColor="none"
                      disabled
              >{{ testbankExamHistory.examType === 'QUIZ' ? $t('testBank.write') : $t('testBank.survey') }}</GrmBtn>
            </div>
          </div>
        </div>
        <div class="flex gap-x-4">
          <div class="min-w-0 flex-1 flex flex-col gap-y-2">
            <div class="w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6">{{ $t("testBank.meetingRoom") }}</div>
            <p class="text-sm break-words">{{ testbankExamHistory.roomTitle }}</p>
          </div>
          <div class="min-w-0 flex-1 flex flex-col gap-y-2">
            <div class="w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6">{{ $t("testBank.number.participant") }}</div>
            <p class="text-sm break-words">{{ $t("testBank.count.participant", {'0': testbankExamHistory.roomExamUserCnt }) }}</p>
          </div>
        </div>
        <div class="flex gap-x-4">
          <div class="min-w-0 flex-1 flex flex-col gap-y-2">
            <div class="w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6">{{ $t("testBank.limit") }}</div>
            <p class="text-sm break-words">{{ examDuration(testbankExamHistory) }}</p>
          </div>
          <div class="min-w-0 flex-1 flex flex-col gap-y-2">
            <div class="w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6">{{ $t("testBank.period") }}</div>
            <p class="text-sm break-words">{{ testbankExamHistory.beginDate }} ~ {{ testbankExamHistory.endDate }}</p>
          </div>
        </div>
        <div v-if="testbankExamHistory.examType === 'QUIZ'" class="border-t border-gray-300 pt-6 flex flex-col items-center">
          <p class="font-bold">{{ $t("testBank.answerTable") }}</p>
          <TestbankResultCorrectTable disabled class="mt-4" :questionList="testbankExamHistory.bankExam.questionList" />
        </div>
      </div>
    </div>
    <RoomTestbankExamSubmitUserTable class="mt-9" />
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

import GrmBtn from "@/components/Common/button/GrmBtn.vue";
import TestbankResultCorrectTable from "@/components/Room/Testbank/Result/TestbankResultCorrectTable.vue";
import RoomTestbankExamSubmitUserTable from "@/components/Room/Testbank/History/RoomTestbankExamSubmitUserTable.vue";

export default {
  name: 'RoomTestbankHistory',
  components: {
    GrmBtn,
    TestbankResultCorrectTable,
    RoomTestbankExamSubmitUserTable,
  },
  computed: {
    ...mapState('testbank', [
      'testbankExamHistory',
    ]),

    examDuration() {
      return exam => {
        const duration = exam.examDuration;
        const hour = Math.floor(duration / 3600);
        const minute = Math.floor((duration % 3600) / 60);
        const second = duration % 60;
        return `${hour ? hour + this.$t('common.hour') + ' ' : ''}${minute ? minute + this.$t('common.minute') + ' ' : ''}${second ? second + this.$t('common.second') : ''}`;
      }
    }
  },
  methods: {
    ...mapMutations('testbank', [
      'SET_VIEW',
    ]),

    onBack() {
      this.SET_VIEW('history__list');
    },
  }
}
</script>